import { createMuiTheme, makeStyles, createStyles } from '@material-ui/core';
import {isIe10, isIe9} from '@app/helpers/browsers.helper';
import { createTheme } from '@material-ui/core/styles';

declare module '@material-ui/core/styles/createTheme' {
    interface Theme {
        tablerow: {
            primary: string;
            secondary: string;
            border: string;
            selectedSecondary: string;
        };
        grayPalette: {
            weight900: string;
            weight700: string;
            weight600: string;
            weight500: string;
            weight400: string;
            weight300: string;
            weight200: string;
            weight100: string;
        };
        input: {
            border: {
                default: string,
                hovered: string,
                focused: string,
            }
        };
        inputLabel: {
            color: string,
        };
    }
    interface ThemeOptions {
        tablerow?: {
            primary?: string;
            secondary?: string;
            border?: string;
            selectedSecondary?: string;
        };
        grayPalette: {
            weight900: string;
            weight700: string;
            weight600: string;
            weight500: string;
            weight400: string;
            weight300: string;
            weight200: string;
            weight100: string;
        };
        input: {
            border: {
                default: string,
                hovered: string,
                focused: string,
            }
        };
        inputLabel: {
            color: string,
        };
    }
}

const generalFontSize: number = 14;

export const theme = createTheme({
    palette: {
        primary: {
            main: '#0074bd',
            contrastText: '#F8F8F8',
        },
        secondary: {
            main: 'rgba(0, 116, 189, 0.2)',
            contrastText: '#0074BD'
        },
        action: {
            hover: '#F7F7F7',
            selected: 'rgba(0, 116, 189, 0.15)'
        },
        error: {
            main: '#D44431'
        },
        background: {
            default: '#F7F7F7'
        },
        text: {
            primary: '#333333'
        }
    },
    tablerow: {
        primary: '#f8f8f8',
        secondary: '#eee',
        border: '#d8d8d8',
        selectedSecondary: 'rgba(0, 116, 189, 0.25)'
    },
    shape: {
        borderRadius: 4
    },
    typography: {
        fontFamily: [
            'Roboto',
            'IBM Plex Sans',
            'sans serif'
        ].join(','),
        fontSize: generalFontSize,
        body1: {
            fontSize: generalFontSize
        }

    },
    spacing: 8,
    grayPalette: {
        weight900: '#000000',
        weight700: '#202020',
        weight600: '#D0D0D0',
        weight500: '#D8D8D8',
        weight400: '#DCDCDC',
        weight300: '#E0E0E0',
        weight200: '#F0F0F0',
        weight100: '#FFFFFF'
    },
    overrides: {
        MuiFormControlLabel: {
            label: {
                minWidth: 60,
                marginRight: 10
            },
            labelPlacementStart: {
                margin: 0,
                marginLeft: 0,
                marginRight: 0
            }
        }
    },
    input: {
        border: {
            default: '#cccccc',
            hovered: '#999999',
            focused: '#166EFA'
        }
    },
    inputLabel: {
        color: '#656565',
    },
});

const passlyCommonInputStyle: any = {
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.input.border.default}`,
    height: `30px`,
    fontSize: generalFontSize,
    transition: theme.transitions.create(['border-color', 'box-shadow', 'background-color']),

    '&.Mui-focused, &:focus, &$focused': {
        borderColor: theme.input.border.focused,
    },
    '&.MuiInput-multiline': {
        height: `auto`,
    },
    '&:hover': {
        borderColor: theme.input.border.hovered
    },
    '&.Mui-disabled': {
        '&:hover': {
            backgroundColor: theme.palette.background.default
        },
        backgroundColor: theme.palette.background.default
    },
    '&.Mui-error': {
        borderColor: theme.palette.error.main,
    },
};

const passlyCommonInputPadding: any = {
    padding: '8px 8px'
};

const passlyCommonLabelStyle: any = {
    color: theme.inputLabel.color,
    fontFamily: `'Roboto', 'IBM Plex Sans', 'sans-serif'`,
    fontSize: 12,
    fontWeight: 400,
    '&$focused': {
        color: theme.inputLabel.color,
    }
};

export const useLabelStyles = makeStyles(() => createLabelStyles);

export const createLabelStyles = createStyles({
    root: { ...passlyCommonLabelStyle },
    focused: {},
    shrink: {
        transform: isIe9() || isIe10() ? 'translate(0, -15px) scale(1)' : 'translate(0, -5px) scale(1)',
    }
});
